<div class="page-filter card">
    <div class="page-body d-flex flex-wrap">
        <div
            #filterControlsBox

            [ngStyle]="{'display': !isStatic ? 'block' : 'none'}"

            class="col-auto filter-settings"
        >
            <button
                (click)="isSettingsShown = !isSettingsShown"

                class="btn btn-sm btn-primary add-controls"
                type="button"
            >
                <i aria-hidden="true" class="fa fa-plus"></i>
            </button>

            <div
                appClickOutside

                (clickOutside)="onClickOutsideDropdownBox($event)"

                [ngStyle]="{'display': !isSettingsShown ? 'none' : 'block'}"

                aria-labelledby="dropdownMenuButton"
                class="dropdown-menu"
            >
                <div class="form-check d-flex flex-column">
                    <ng-container *ngFor="let filterControl of controls">
                        <app-checkbox
                            *ngIf="filterControl.isRemovable"

                            [(ngModel)]="filterControl.shown"
                            (ngModelChange)="toggleControl(filterControl)"
                        >
                            <ng-container text> {{ filterControl.placeholder }} </ng-container>
                        </app-checkbox>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="col">
            <form [formGroup]="form" autocomplete="off">
                <div class="form-body d-flex flex-wrap">
                    <ng-container *ngFor="let filterItem of controls">
                        <ng-container *ngIf="filterItem.shown && filterItem.block">
                            <div
                                class="form-body d-flex flex-wrap col-12 separate-block">
                                <h4 class="col-12">{{ filterItem.placeholder }}</h4>
                                <div
                                    *ngFor="let control of filterItem.controls"
                                    [ngSwitch]="control.componentType"
                                    [ngClass]="{
                                        'col-lg-2': formControlSmallerWidth && filterItem.block,
                                        'col-lg-3': !formControlSmallerWidth && filterItem.block
                                    }"
                                >
                                    <app-select
                                        *ngSwitchCase="componentTypes.Select"
                                        [control]="control"
                                        [formControlName]="control.name"
                                    ></app-select>
                                    <app-radio-group
                                        *ngSwitchCase="componentTypes.RadioGroup"
                                        [control]="control"
                                        [formControlName]="control.name"
                                    ></app-radio-group>
                                    <app-autocomplete
                                        *ngSwitchCase="componentTypes.Autocomplete"
                                        [control]="control"
                                        [formControlName]="control.name"
                                    ></app-autocomplete>
                                    <app-datepicker
                                        *ngSwitchCase="componentTypes.Datepicker"
                                        [control]="control"
                                        [formControlName]="control.name"
                                    ></app-datepicker>
                                    <app-checkbox
                                        *ngSwitchCase="componentTypes.Checkbox"
                                        [formControlName]="control.name"
                                        [control]="control"
                                    >
                                        <ng-container text>{{control.placeholder}}</ng-container>
                                    </app-checkbox>
                                    <app-amount-input
                                        *ngSwitchCase="componentTypes.AmountInput"
                                        [control]="control"
                                        [formControlName]="control.name"
                                        [allowNegative]="true"
                                    ></app-amount-input>
                                    <app-panel-input
                                        *ngSwitchDefault
                                        [control]="control"
                                        [formControlName]="control.name"
                                    ></app-panel-input>
                                    <app-slide-toggle
                                        *ngSwitchCase="componentTypes.SlideToggle"
                                        [formControlName]="control.name"
                                        [control]="control"
                                    ></app-slide-toggle>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="filterItem.shown && !filterItem.block">
                            <div
                                *ngFor="let control of filterItem.controls"
                                [ngSwitch]="control.componentType"
                                class="form-group col col-sm-6 mb-0"
                                [ngClass]="{
                                'col-lg-2': formControlSmallerWidth,
                                'col-lg-3': !formControlSmallerWidth
                                }"
                            >
                                <app-select
                                    *ngSwitchCase="componentTypes.Select"
                                    [control]="control"
                                    [formControlName]="control.name"
                                ></app-select>
                                <app-radio-group
                                    *ngSwitchCase="componentTypes.RadioGroup"
                                    [control]="control"
                                    [formControlName]="control.name"
                                ></app-radio-group>
                                <app-autocomplete
                                    *ngSwitchCase="componentTypes.Autocomplete"
                                    [control]="control"
                                    [formControlName]="control.name"
                                ></app-autocomplete>
                                <app-datepicker
                                    *ngSwitchCase="componentTypes.Datepicker"
                                    [control]="control"
                                    [formControlName]="control.name"
                                ></app-datepicker>
                                <app-slide-toggle
                                    *ngSwitchCase="componentTypes.SlideToggle"
                                    [formControlName]="control.name"
                                    [control]="control"
                                ></app-slide-toggle>
                                <app-checkbox
                                    *ngSwitchCase="componentTypes.Checkbox"
                                    [formControlName]="control.name"
                                    [control]="control"
                                >
                                    <ng-container text>{{control.placeholder}}</ng-container>
                                </app-checkbox>
                                <app-amount-input
                                    *ngSwitchCase="componentTypes.AmountInput"
                                    [control]="control"
                                    [formControlName]="control.name"
                                    [allowNegative]="true"
                                ></app-amount-input>
                                <app-panel-input
                                    *ngSwitchDefault
                                    [control]="control"
                                    [formControlName]="control.name"
                                ></app-panel-input>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </form>
        </div>
        <div *ngIf="isStatic" class="form-actions col-12 col-md-auto">
            <button (click)="onFormSubmit()" class="btn btn-sm btn-primary" type="button">Submit</button>
        </div>
        <div class="form-actions col-12 col-md-auto">
            <button (click)="onReset()" class="btn btn-sm btn-outline-primary" type="button">Clear</button>
        </div>
    </div>
</div>

